'use client';

import '@/assets/css/components/signpost.css';

import { DialogTitle } from '@radix-ui/react-dialog';

import { SignpostContent } from '@/components/modals/signpost/signpost-content';
import { Dialog, DialogContent } from '@/components/ui/dialog';

interface SignpostProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}

export const Signpost = ({ isOpen, setIsOpen }: SignpostProps) => {
  return (
    <Dialog
      open={isOpen}
      onOpenChange={setIsOpen}
    >
      <DialogTitle className="hidden">Signpost</DialogTitle>
      <DialogContent className="h-[95vh] p-3 outline-none focus:outline-none md:py-10">
        <SignpostContent setIsOpen={setIsOpen} />
      </DialogContent>
    </Dialog>
  );
};
